import { z } from "zod";

import {
	BasicCustomMailForReservationInputSchema,
	BasicCustomMailForShoppingInputSchema,
	BasicCustomMailItemSendOptionalInputSchema,
	BasicCustomMailItemSendRequiredInputSchema,
	BasicCustomMailSettingInputSchema,
} from "@/lib/zod/__generated__/validation-schema";

const customMailForReservationSchema = BasicCustomMailForReservationInputSchema.extend({
	//##################################################
	// 送信必須の項目のバリデーション
	//##################################################
	atCreated: BasicCustomMailItemSendRequiredInputSchema.extend({
		text: z.string().max(3_000),
	}),
	atUpdated: BasicCustomMailItemSendRequiredInputSchema.extend({
		text: z.string().max(3_000),
	}),
	atCanceled: BasicCustomMailItemSendRequiredInputSchema.extend({
		text: z.string().max(3_000),
	}),
	atRequest: BasicCustomMailItemSendRequiredInputSchema.extend({
		text: z.string().max(3_000),
	}),
	atConfirmed: BasicCustomMailItemSendRequiredInputSchema.extend({
		text: z.string().max(3_000),
	}),
	atDeclined: BasicCustomMailItemSendRequiredInputSchema.extend({
		text: z.string().max(3_000),
	}),

	//##################################################
	// 送信必須ではない項目のバリデーション
	//##################################################
	atCheckInBefore_07days: BasicCustomMailItemSendOptionalInputSchema.extend({
		text: z.string().max(3_000),
		shouldSendEmail: z.boolean(),
	}),
	atCheckInBefore_01days: BasicCustomMailItemSendOptionalInputSchema.extend({
		text: z.string().max(3_000),
		shouldSendEmail: z.boolean(),
	}),
	atCheckInBefore_00days: BasicCustomMailItemSendOptionalInputSchema.extend({
		text: z.string().max(3_000),
		shouldSendEmail: z.boolean(),
	}),
	atCheckOutAfter_01days: BasicCustomMailItemSendOptionalInputSchema.extend({
		text: z.string().max(3_000),
		shouldSendEmail: z.boolean(),
	}),
});

const customMailForShoppingSchema = BasicCustomMailForShoppingInputSchema.extend({
	//##################################################
	// 送信必須の項目のバリデーション
	//##################################################
	atCreated: BasicCustomMailItemSendRequiredInputSchema.extend({
		text: z.string().max(3_000),
	}),
});

export const basicCustomMailSettingSchema = BasicCustomMailSettingInputSchema.extend({
	mailFooterExternalLink: z.string().url().nullable().or(z.literal("")),
	forReservation: customMailForReservationSchema,
	forShopping: customMailForShoppingSchema,
});

export type BasicCustomMailSettingFormData = z.infer<typeof basicCustomMailSettingSchema>;
